"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reduxForm = require("redux-form");

var _paymentFormValidation = require("utils/paymentFormValidation");

var _recompose = require("recompose");

var _ramda = require("ramda");

var _ramda2 = _interopRequireDefault(_ramda);

var _paymentErrorMessage = require("utils/paymentErrorMessage");

var _paymentErrorMessage2 = _interopRequireDefault(_paymentErrorMessage);

var _PaymentForm = require("./component/PaymentForm");

var _PaymentForm2 = _interopRequireDefault(_PaymentForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PaymentFormContainer = function PaymentFormContainer(props) {
  return _react2.default.createElement(_PaymentForm2.default, {
    paypalContainerId: props.paypalContainerId,
    paypalEmail: props.paypalEmail,
    paypalConfirmationHelpText: props.paypalConfirmationHelpText,
    fields: props.fields,
    error: (0, _paymentErrorMessage2.default)(props._error),
    handleSubmit: props.handleSubmit,
    makingPayment: props.makingPayment,
    lockCountryAndVat: false,
    validatingVat: props.asyncValidating === "vatNo",
    validatingPromoCode: props.asyncValidating === "promoCode",
    paypalIconSrc: "/icons/pay-with-paypal.png",
    backLink: props.backLink,
    paymentLogosSrc: props.paymentLogosSrc,
    braintreeLink: props.braintreeLink,
    updatePrice: props.updatePrice,
    showPromoCode: props.showPromoCode,
    isAnnualSubscription: props.isAnnualSubscription,
    promoCodeMessage: props.promoCodeMessage,
    renderCaptcha: props.renderCaptcha,
    paypalPaymentBoxError: props.paypalPaymentBoxError,
    creditCardPrepare: props.creditCardPrepare
  });
};

exports.default = (0, _reduxForm.reduxForm)({
  fields: ["name", "company", "address", "address2", "postalCode", "state", "city", "country", "vatNo", "subscribe", "acceptTos", "paymentMethod", "promoCode", "validatingField", "isVatValid", "isPromoCodeValid", "projectName", "projectDetails", "captcha"],
  form: "checkout",
  validate: _paymentFormValidation.validate,
  asyncValidate: _paymentFormValidation.asyncValidate,
  asyncBlurFields: ["vatNo", "promoCode"]
})((0, _recompose.lifecycle)({
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    if (this.props.fields.paymentMethod.value === "cc" && nextProps.fields.paymentMethod.value === "paypal") {
      if (this.props.onPayPalPrepare) {
        this.props.onPayPalPrepare();
      }
    }

    if (nextProps.fields.paymentMethod.value == "cc") {
      this.props.setCreditCardState();
    }

    if (this.props.asyncValidating && this.props.asyncValidating !== nextProps.asyncValidating && nextProps.asyncValidating === false && !nextProps.makingPayment
    // && (this.props.fields.vatNo.value && !nextProps.fields.vatNo.value)
    ) {
        nextProps.updatePrice(nextProps.fields.country.value, nextProps.fields.state.value, nextProps.fields.city.value, nextProps.fields.postalCode.value, nextProps.fields.vatNo.value, nextProps.fields.vatNo.valid);
      }
    if (this.props.fields.state !== nextProps.fields.state || nextProps.fields.postalCode !== this.props.fields.postalCode && nextProps.fields.postalCode.active === false && nextProps.fields.postalCode.dirty) {
      nextProps.updatePrice(nextProps.fields.country.value, nextProps.fields.state.value, nextProps.fields.city.value, nextProps.fields.postalCode.value, nextProps.fields.vatNo.value, nextProps.fields.vatNo.valid);
    }
    if (this.props.fields.state.value !== nextProps.fields.state.value) {
      this.props.fields.city.onChange({ value: "", name: "" });
    }

    if (this.props.onCountryChange) {
      if (this.props.fields.country.value && this.props.fields.country.value !== nextProps.fields.country.value) {
        this.props.fields.state.onChange({ value: "", name: "" });
        this.props.fields.city.onChange({ value: "", name: "" });
        this.props.fields.captcha.onChange({ value: "" });
        this.props.onCountryChange(nextProps.fields.country.value);
      }
    }
  }
})(PaymentFormContainer));
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/PaymentForm/PaymentForm.jsx
// module id = 2507
// module chunks = 0